import { Component, OnInit, EventEmitter, Output, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// tslint:disable-next-line:max-line-length
import { FormGroup, FormBuilder, Validators, ValidationErrors, FormGroupDirective, FormArray, AbstractControl } from '@angular/forms';
import { Constants, AlertService, AppUtils, ActionModeEnum } from 'src/app/shared';
import * as ObjectUtils from 'util';
import * as cloneDeep from 'lodash/cloneDeep';
import { SiteService, CommonService } from 'src/app/services/index';
@Component({
  selector: 'app-node-detail',
  templateUrl: './node-detail.component.html',
  styleUrls: ['./node-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NodeDetailComponent implements OnInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  @Output() closeHandler: EventEmitter<any> = new EventEmitter();
  formMasterGroup: FormGroup;
  nodeDetails: any;
  inputSensors: any;
  outputSensors: any;
  load: any;
  actionMode: ActionModeEnum = ActionModeEnum.Creating;
  get getActionModeEnum() {return ActionModeEnum; }
  constructor(public dialogRef: MatDialogRef<NodeDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService,
    private commonService: CommonService) {
    this.initNodeDetailsObj();
    this.load = {};
    this.inputSensors = [];
    this.outputSensors = [];
    if (this.data) {
      this.inputSensors = data.inputSensors;
      this.outputSensors = data.outputSensors;
      this.load = data.load;
     if (this.data.actionMode === ActionModeEnum.Editing) {
      this.nodeDetails.nodeName = data.nodeName;
      this.nodeDetails.selectedInputSensors = data.selectedInputSensors;
      this.nodeDetails.selectedOutputSensors = data.selectedOutputSensors;
      this.nodeDetails.inputSensorCriteria = data.inputSensorCriteria;
      this.nodeDetails.outputSensorCriteria = data.outputSensorCriteria;
      this.actionMode = ActionModeEnum.Editing;
      this.nodeDetails.actionMode = this.actionMode;
     }
    }
    this.formMasterGroup = this.fb.group({
      nodeNameCtr: ['',  [Validators.required, Validators.minLength(1), Validators.maxLength(15)]],
      inputSensorCtr: ['',  [Validators.required]],
      outputSensorCtr: ['']
    });
  }
private initNodeDetailsObj = () => {
  this.nodeDetails = {};
  this.nodeDetails.nodeName = null;
  this.nodeDetails.inputSensorCriteria = [];
  this.nodeDetails.outputSensorCriteria = [];
  this.nodeDetails.selectedOutputSensors = [];
  this.nodeDetails.selectedOutputSensors = [];
  this.nodeDetails.actionMode = this.actionMode;
}
  ngOnInit() {
  }
  public buildInputParams = () => {
    this.nodeDetails.inputSensorCriteria = [];
    if (this.load.type === 'Turning' && this.load.subType === 'Generic Load') {
      if (this.nodeDetails.selectedInputSensors != null &&
        this.nodeDetails.selectedInputSensors.length > 1) {
          this.nodeDetails.selectedInputSensors.splice(1);
        }
      }
      for (let i = 0; i < this.nodeDetails.selectedInputSensors.length; i++) {
        // tslint:disable-next-line:max-line-length
        this.nodeDetails.inputSensorCriteria.push(this.findByRId(this.inputSensors, this.nodeDetails.selectedInputSensors[i].sensorRId).sensorRId);
      }
  }
  public buildOutputParams = () => {
    this.nodeDetails.outputSensorCriteria = [];
    for (let i = 0; i < this.nodeDetails.selectedOutputSensors.length; i++) {
      // tslint:disable-next-line:max-line-length
      this.nodeDetails.outputSensorCriteria.push(this.findByRId(this.outputSensors, this.nodeDetails.selectedOutputSensors[i].sensorRId).sensorRId);
    }
  }
  private findByRId = (arr: any, rId: any) => {
    if (arr !== undefined) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].sensorRId === rId) {
        return arr[i];
      }
    }}
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formMasterGroup.get(fieldName).hasError(errorCode);
  }
  public submit = () => {
    this.commonService.sendNodeDetailSubject(this.nodeDetails);
    this.dialogRef.close();
  }
  public close = (e: any) => {
    e.preventDefault();
    this.closeHandler.observers.length > 0 ? this.closeHandler.emit() : this.dialogRef.close();
  }
  public delete = (e: any) => {
    e.preventDefault();
    this.nodeDetails.actionMode = ActionModeEnum.Deleting;
    this.commonService.sendNodeDetailSubject(this.nodeDetails);
    this.dialogRef.close();
  }
}
